import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PartecipanteService from "../services/PartecipanteService";
import { useRef } from "react";


export default function CaricamentoLogin(props) {

    const [error, setError] = useState(null);
   const [loading, setLoading] = useState(true);
  const calledRef = useRef(false);
  const navigate = useNavigate();

useEffect(() => {
  console.log("CaricamentoLogin useEffect");
   if (calledRef.current) return;
    calledRef.current = true;
  const params = new URLSearchParams(window.location.search);
  const buffer = params.get("buffer");
  const goToLoginWithError = (msg) => {
      navigate("/login", { replace: true, state: { errorMessage: msg } });
    };
  const comId = sessionStorage.getItem("comId"); 
  if (!buffer) { setError("Buffer"); return; }

  (async () => {
    try {
      console.log("Validating buffer:", buffer, "for comId:", comId); 
      const res = await PartecipanteService.spidCompleteCatania(buffer, Number(comId));
      if (res?.data?.esito === 1 && res?.data?.token) {
        sessionStorage.setItem('partecipante', JSON.stringify(btoa(res.data.partecipante.datiPartecipante.dparCf)));
        sessionStorage.setItem('token', btoa(res.data.token));
        props.aggiornaRicaricaPartecipante()
         navigate("/", { replace: true });
        } else if (res?.data?.esito === -100) {
          goToLoginWithError("Credenziali errate");
        } else if (res?.data?.esito === -101) {
          goToLoginWithError("Utente non autorizzato per questo comune");
        } else if (res?.data?.esito === -102) {
          goToLoginWithError("Accesso consentito solo ai residenti di questo comune");
        } else {
          goToLoginWithError("Impossibile completare l’accesso SPID");
        }
    } catch (e) {
      console.error(e);
      setError('Errore durante la validazione del buffer'); goToLoginWithError("Errore durante la validazione del buffer");
      } finally {
        setLoading(false);
      }
  })();
}, []);

 return (
        <>
           
        </>
    )
}
